export type * from '@/generated/graphql/generic';

export const CurrenciesDocument = () => import('@/generated/graphql/generic').then(module => module.CurrenciesDocument);